
import { defineComponent, PropType } from '@vue/runtime-core'
import ModalBase from '@/components/genenral/ModalBase.vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'ModalEventNotEntry',

  components: {
    ModalBase,
    Button
  },

  props: {
    lead: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    btnLabel: {
      type: String,
      required: true
    },
    btnLink: {
      type: String,
      required: true
    },
    closeNotEntryModal: {
      type: Function as PropType<() => void>,
      required: true
    }
  }
})
